import React from "react";
import BriefingItem from "./BriefingItem/BriefingItem";

const BriefingsList = ({ list, hasAdmin, renderDeleteConfirm }) => {
  if (list.length === 0) {
    return (
      <div style={{ marginLeft: 14 }}>
        <b>No Briefing notes matched that searching criteria</b>
      </div>
    );
  }
  return (
    <>
      {list.map((prop) => (
        <BriefingItem
          key={prop.id}
          data={prop}
          hasAdmin={hasAdmin}
          onDelete={renderDeleteConfirm}
        />
      ))}
    </>
  );
};

export default BriefingsList;
